import { BaseEnv } from '@aipb/gulliver/env/model';
import { FrameService } from '@aipb/gulliver/frame/data-access';
import { getAppVersion } from '@aipb/shared/util/other';
import { inject, Injectable } from '@angular/core';
import { SetupHandler } from './setup.handler';
import { AppConfigService } from '../app.config.service';

@Injectable({
  providedIn: 'root'
})
export class FrameHandler extends SetupHandler {
  frame = inject(FrameService);
  appConfigService = inject(AppConfigService);

  constructor() {
    super('frame.handler');
  }

  handle(env: BaseEnv) {
    this.frame.init(env.applications);
    this.addLogMessage(`init applications ${Object.keys(env.applications).join(', ')}`);

    const appVersion = getAppVersion(this.appConfigService.project);
    this.frame.setAppVersion(appVersion);
    this.addLogMessage(`set app version to ${appVersion}`);
  }
}
